<template>
  <div class="filter-container">
    <template v-for="(item) in filterList">
      <div :key="item.filterName" class="filter-split" />
      <div :key="item.value" class="filter-wraper">
        <div class="filter-name text-overflow-ellipsis-2">
          {{ item.filterName }}
        </div>
        <ul class="filter-container-ul">
          <li
            v-for="(item1, index1) in item.dataList"
            :key="item1.name"
            class="filter-content"
            :class="{'active-item': item1.selected}"
            @click="changeFilter(item1, index1, item.filterType)"
          >
            <div
              v-if="item.filterType === 'difficulty' && index1 >= 1 && !item1.name"
              class="filter-text"
              @mouseenter="changeColor(item1, index1, item.filterType, true)"
              @mouseleave="changeColor(item1, index1, item.filterType)"
            >
              <DiffcultyRate
                :max="+item1.value"
                :rate-level="+item1.value"
                :on-color="item1.color"
              />
            </div>
            <div v-else class="filter-text">
              {{ item1.name }}
            </div>
          </li>
        </ul>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin';
import DiffcultyRate from 'components/common/Rate';

export default {
  components: {
    DiffcultyRate,
  },
  mixins: [mixin],
}
</script>

<style lang="scss" scoped>
.filter-split {
  width: calc(100% - 117px);
  position: relative;
  top: 0;
  left: 117px;
  margin: 9px 0 25px;
  border-bottom: 1px solid #f2f2f2;
}

.filter-wraper {
  display: flex;
  font-size: 14px;
  font-weight: 400;
  line-height: 14px;

  .filter-name {
    width: 107px;
    max-height: 28px;
    flex-shrink: 0;
    position: relative;
    top: 7px;
    margin-right: 10px;
    color: var(--txt-color-lv2);
    cursor: default;
  }

  ul {
    list-style: none;
  }

  .filter-container-ul {
    display: flex;
    flex-wrap: wrap;
    padding: 0;
    margin: 0;

    .filter-content {
      transition: color 0.2s linear;
    }

    .active-item {
      background: var(--txt-color-link3);
      border-radius: 50px;
      color: var(--txt-color-link);
    }

    .filter-content:not(.active-item):hover {
      color: var(--txt-color-link);
    }

    .filter-text {
      padding: 7px 14px;
    }
  }

  li {
    padding: 0;
    margin-right: 26px;
    margin-bottom: 16px;
    cursor: pointer;
    border-radius: 50px;
    overflow: hidden;
  }
}
</style>
